export default __webpack_public_path__ + "static/media/tv.458d0257.jpg";